import { render, staticRenderFns } from "./AgencyApprovals.vue?vue&type=template&id=2e6d92b3&scoped=true"
import script from "./AgencyApprovals.vue?vue&type=script&lang=js"
export * from "./AgencyApprovals.vue?vue&type=script&lang=js"
import style0 from "./AgencyApprovals.vue?vue&type=style&index=0&id=2e6d92b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6d92b3",
  null
  
)

export default component.exports